<script lang="ts">
  /**
   * One generic sheet for an explanation that does not fit on the card it
   * belongs to: the handicap, why there is none against the computer, how
   * the daily works. Every call site routes through this one component, on
   * the shell's `Sheet` (`docs/decisions/0047`): the parent owns `open` and
   * closes it in `onclose`.
   */
  import { Sheet } from '@artibens/app-shell';

  const {
    open,
    label,
    text,
    onclose,
    testid,
  }: {
    open: boolean;
    label: string;
    text: string;
    onclose: () => void;
    testid?: string | undefined;
  } = $props();
</script>

<Sheet {open} title={label} {onclose} {testid}>
  <p class="explanation">{text}</p>
</Sheet>

<style>
  .explanation {
    margin: 0;
    font: var(--ui-text-body);
    line-height: 1.55;
    color: var(--ui-ink);
  }
</style>
